<template>
  <no-ssr>
    <section class="header">
      <div  :class="[classHeader,{'header-fix':reachedTop , 'header-abs' :  EntranceGet } ]" >
        <header-menu :searchForm="searchForm"/>
      </div>
    </section>
  </no-ssr>
</template>

<script>
  import HeaderMenu from './HeaderMenu.vue'

  export default {
    components: {
      HeaderMenu,
    },
    data() {
      return {
        limitPosition: 400,
        lastPosition: 0,
        scrolled: false,
      };
    },
    props: {
      classHeader: { type: String, default: 'header-inner'},
      searchForm:  { type: Boolean, default: true},
    },
    methods: {
      /* entranceStyle(){
         console.log(this.entranceButton);
         this.entranceButton = !this.entranceButton ;
         console.log(this.entranceButton);
         return /!*this.$store.state.scrollPosition > 100 &&*!/ this.entranceButton;
       },*/
    },
    computed: {
      reachedTop() {
        //let entrance = this.$store.state.menu.entranceButton && this.$store.state.menu.mobileMenuOpen;
        return this.$store.state.scrollPosition > 100;
      },
      EntranceGet() {
        let entrance = this.$store.state.menu.entranceButton && this.$store.state.menu.mobileMenuOpen;
        if(typeof document !== "undefined") {
          document.getElementsByTagName("body")[0].style.overflow = entrance ? "hidden" : null;
        }
        return entrance;
      },
    },
  }
</script>

<style lang="scss">
  .header {
    height: 80px;
    @media (max-width: 990px) {
      height: 60px;
    }
    .header-inner {
      position: relative;
      @include linear-gradient(to right, $color-blue-2 0%, $color-blue-4 100%);
      z-index: 50;
      @include ease(all, 0.3s);
      &__inner {
        padding: 130px 0;
        display: flex;display: -ms-flexbox;
        flex-flow: row nowrap;
        justify-content: space-between; -ms-flex-pack: justify;
        align-items: flex-start;
      }
      &.header-fix {
        position: fixed;
        left: 0;
        right: 0;
        top: -80px;
        transform: translateY(80px);
        z-index: 900;
        .search-form {
          display: none;
        }
      }
    }
    .header-index {
      // @include linear-gradient(to right, $color-blue-2 0%, #41a7c1 100%);
      position: relative;
      z-index: 50;
      @include ease(all, 0.3s);
      &.header-fix {
        @include linear-gradient(to right, $color-blue-2 0%, $color-blue-4 100%);
        position: fixed;
        left: 0;
        right: 0;
        top: -80px;
        transform: translateY(80px);
        z-index: 900;
        .search-form {
          display: none;
        }
      }
      // overflow: hidden;
    }

    @media (max-width: $media_md) {
      .header-inner {
        position: fixed;
        left: 0;
        right: 0;
        top:0;
        z-index: 9999;
        transform: none;
        .header-menu-row {
          max-width: 100%;
          height: 70px;
        }
      }
      .header-index {
        .header-menu-row {
          max-width: 100%;
          background: none;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// components/header/HeaderInner.vue